import { useMemo } from 'react';

import { getBoardAdmins } from '@trello/business-logic/board';

import { useBoardAdminsQuery } from './BoardAdminsQuery.generated';

export const useBoardAdmins = (idBoard: string) => {
  const { data, loading, error } = useBoardAdminsQuery({
    variables: {
      idBoard,
    },
    fetchPolicy: 'cache-only',
    waitOn: ['CurrentBoardFull'],
  });

  const members = useMemo(() => data?.board?.members ?? [], [
    data?.board?.members,
  ]);
  const memberships = useMemo(() => data?.board?.memberships ?? [], [
    data?.board?.memberships,
  ]);
  const boardAdmins = useMemo(() => getBoardAdmins(members, memberships), [
    members,
    memberships,
  ]);

  return { boardAdmins, loading, error };
};
